/**
 *
 * @module adobeActivationResult
 *
 */

import Check from 'check-types';
import Services from './../../services/entry';

const IdentityToken = Services.Token.IdentityToken;
const TemporaryGrant = Services.Token.TemporaryGrant;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class AdobeActivationResult
 *
 */
export default class AdobeActivationResult {

    /**
     *
     * @param {SDK.Services.Token.IdentityToken} identityToken
     * @param {SDK.Services.Token.TemporaryGrant} temporaryGrant
     *
     */
    constructor(identityToken, temporaryGrant) {

        const errorMessage = {
            ctor: 'AdobeActivationResult(identityToken, temporaryGrant)',
            get identityToken() {
                return `${this.ctor} needs IdentityToken instance`;
            },
            get temporaryGrant() {
                return `${this.ctor} needs TemporaryGrant instance`;
            }
        };

        instanceStrict(identityToken, IdentityToken, errorMessage.identityToken, InvalidArgumentException);
        instanceStrict(temporaryGrant, TemporaryGrant, errorMessage.temporaryGrant, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {SDK.Services.Token.IdentityToken}
         *
         */
        this.identityToken = identityToken;

        /**
         *
         * @access private
         * @type {SDK.Services.Token.TemporaryGrant}
         *
         */
        this.temporaryGrant = temporaryGrant;

    }

}



// WEBPACK FOOTER //
// ./src/identity/adobe/adobeActivationResult.js